import { useSelector } from "react-redux";
import media from "styled-media-query";
import { State } from "../../../redux";
import styled from "styled-components";

import { Button, ColorV2, Modal, Text } from "@adoptaunabuelo/react-components";
import { AlertTriangle } from "lucide-react";

const Container = styled.div`
	display: flex;
	flex-direction: column;
	padding-bottom: 16px;
`;
const Disclaimer = styled.div`
	display: flex;
	background-color: ${ColorV2.surface.secondarySoft};
	padding: 8px 16px;
	border-radius: 8px;
	margin-top: 16px;
	gap: 8px;
`;
const Footer = styled.div`
	display: flex;
	justify-content: flex-end;
	margin-top: 16px;
	gap: 8px;
	${media.lessThan("medium")`
        flex-direction: column-reverse;
	`}
`;

const AddressConfirmationModal = (props: AddressConfirmationModalProps) => {
	const isMobile = useSelector((state: State) => state.screen.isMobile);

	return (
		<Modal
			isVisible={props.isVisible}
			onClose={props.onClose}
			title="¿La dirección de envío es correcta?"
			type={isMobile ? "full-screen" : "default"}
			style={{
				backgroundColor: "white",
			}}
			hideClose={true}
		>
			<Container>
				<Text type="c2" style={{ color: ColorV2.text.neutralMedium }}>
					Dirección
				</Text>
				<Text type="p">
					{props.location.route} {props.location.routeNumber}
					{props.location.routeInfo
						? ", " + props.location.routeInfo
						: ""}
				</Text>
				<Text type="p">
					{props.location.zipCode}, {props.location.city}
				</Text>
				<Text type="p">{props.location.country}</Text>
				<Disclaimer>
					<AlertTriangle
						height={16}
						width={16}
						color={ColorV2.surface.secondaryHard}
					/>
					<Text
						type="p2"
						style={{
							color: ColorV2.surface.secondaryHard,
							flex: 1,
						}}
					>
						Una vez confirmada, el envío se realizará a esta
						dirección y no podremos hacer cambios.
					</Text>
				</Disclaimer>
				<Footer>
					<Button
						size={isMobile ? "normal" : "small"}
						style={{
							backgroundColor: "white",
							color: ColorV2.text.neutralHard,
						}}
						onClick={props.onClose}
					>
						Cambiar dirección
					</Button>
					<Button
						size={isMobile ? "normal" : "small"}
						onClick={props.onConfirm}
					>
						Confirmar
					</Button>
				</Footer>
			</Container>
		</Modal>
	);
};
export default AddressConfirmationModal;
export interface AddressConfirmationModalProps {
	isVisible: boolean;
	location: {
		route: string;
		routeNumber: string;
		routeInfo?: string;
		city?: string;
		zipCode: string;
		country: string;
	};
	onClose: () => void;
	onConfirm: () => void;
}
